import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { catchError, map, retry } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { PlaceViewModel } from "../models/main/place.model";
import { GlobalService } from "./global.service";
import { ApiEnum, HttpDataService } from "./http-data.service";

@Injectable({
	providedIn: "root",
})
export class HeaderService {
	constructor(
		private readonly _httpDataService: HttpDataService,
		private readonly _translateService: TranslateService,
		private readonly _global: GlobalService,
	) {}

	getPlaces(): any {
		/*
        // return a promise with just an empty array
        let promise: any = new Promise((resolve, reject) => {
            let places = [];
            this._global.setPlaces(places);
            resolve(places); 
        });

        return from(promise);
*/

		// Should have been a call to the backend, but we don't have a backend
		return this._httpDataService
			.get$<
				PlaceViewModel[]
			>(ApiEnum.API_ROOT, environment.endpoint.place.get)
			.pipe(
				map((places) => {
					for (let i = 0; i < places.length; i++) {
						switch (places[i].typeName) {
							case "Country":
								places[i].icon = "/assets/icons/country.svg";
								places[i].url =
									`/country/${places[i]["country"]}`;
								places[i].name = this._translateService.instant(
									`countries.${places[i]["countryName"]}`,
								);
								places[i].code = this._translateService.instant(
									`countries.${places[i]["country"]}`,
								);
								break;
							case "Service":
								places[i].id = places[i]["id"];
								places[i].icon = "/assets/icons/service.svg";
								places[i].url =
									`/contracts/${places[i]["id"]}`;
								places[i].name = places[i]["serviceName"];
								places[i].code = places[i]["service"];
								break;
							case "Site":
								places[i].id = places[i]["id"];
								places[i].icon = "/assets/icons/plant.svg";
								places[i].url = `/sites/${places[i]["id"]}`;
								places[i].name = places[i]["siteName"];
								places[i].code = places[i]["site"];
								break;
							case "Area":
								places[i].id = places[i]["id"];
								places[i].icon = "/assets/icons/service.svg";
								places[i].url = `/area/${places[i]["area"]}`;
								places[i].name = places[i]["areaName"];
								places[i].code = places[i]["area"];
								break;
							case "Department":
								places[i].id = places[i]["id"];
								places[i].icon = "/assets/icons/service.svg";
								places[i].url =
									`/department/${places[i]["department"]}`;
								places[i].name = places[i]["departmentName"];
								places[i].code = places[i]["department"];
						}

						places[i].typeNameTranslation =
							this._translateService.instant(
								`header.placeTypes.${places[i].typeName}`,
							);
					}
					this._global.setPlaces(places);
					return places;
				}),
				retry(3),
				catchError(
					this._httpDataService.handleError<PlaceViewModel[]>(
						"getPlaces",
					),
				),
			);
	}
}
